import PropTypes from 'prop-types';
import React, { Component } from 'react';
import i18next from "../../i18n";
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { getFileAttachmentErrorMessage } from '../helpers/CheckFunctions';
const mime = require('mime-types');
export class FileField extends Component {
    static propTypes = {
        col: PropTypes.number,
        allowedExtensions: PropTypes.array,
        maxSize: PropTypes.number, //byte
        label: PropTypes.string,
        name: PropTypes.string,
        check: PropTypes.bool,
        required: PropTypes.bool,
        handleChange: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            file: null
        }
        this.changeFile = this.changeFile.bind(this);
        this.removeFile = this.removeFile.bind(this);
    }
    render() {
        const { required, allowedExtensions, check, col, label, name } = this.props;
        const { file, badExtension, title } = this.state;
        return (
            <div className={`col-lg-${col ? col : 12}`}>
                <div className="form-group">
                    <label>&nbsp;</label>
                    {title ?
                        <label className="upload-file-label">{title}<span className="close-btn" onClick={this.removeFile}></span></label>
                        :
                        <>
                            <label className={"upload-file-label upload-file-btn"} onClick={() => document.getElementById("file-iput-controll" + (name ? name : "")).click()}>{label ? label : i18next.t("addFile")}</label>
                            <input className="file-select" name="file" id={"file-iput-controll" + (name ? name : "")} accept={allowedExtensions?.length > 0 ? allowedExtensions.map(item => mime.lookup(item)).join(",") : ""} onChange={this.changeFile} type="file" style={{ display: "none" }} />
                        </>
                    }
                    {check && !file && !badExtension && required &&
                        <div className="help-block">{i18next.t("requiredField")}</div>
                    }
                </div>
            </div>
        );
    }
    changeFile(e) {
        const { allowedExtensions, maxSize } = this.props;
        let fileInfo = null;
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            let message = getFileAttachmentErrorMessage(file, allowedExtensions, maxSize);            
            if (message) {
                showModalDialog("loadingDialog", i18next.t("message"), "", <div className="info-message">{message}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: () => hideModalDialog("loadingDialog"), class: "btn-primary" }]);
                return;
            }
            fileInfo = {
                file: file,
                title: file.name
            }
            this.setState({
                badExtension: fileInfo.badExtension,
                file: fileInfo.file,
                title: fileInfo.title
            });
        }
        if (this.props.handleChange) {
            this.props.handleChange(fileInfo);
        }
    }
    removeFile(e) {
        this.setState({
            file: null,
            title: "",
            badExtension: false
        });
        if (this.props.handleChange) {
            this.props.handleChange(null);
        }
    }
}